module.exports = __webpack_public_path__ + "static/media/iphone-3-landing-mobile.cf649d33.png";